// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"180":"video","303":"widget","495":"feed","826":"text","946":"dynamic-content"}[chunkId] + "." + {"180":"5bd22d8484fbb7a3e4ae","303":"a42067bf7535793b0ce9","495":"b709120e3902a365f881","826":"f522aa48a364daafa783","946":"ee992bbdfa4e9ce63cb1"}[chunkId] + ".js";
};